module.exports = __webpack_public_path__ + "media/images/loghi/lba_podcast-2c1c0f59c5195214e3cb25bf352caf7e.png";